import type { ReactNode } from 'react';

import { DotsThreeIcon } from '@phosphor-icons/react';

import { cn } from '@shared/lib/utils';
import { Button } from '@shared/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@shared/ui/dropdown-menu';

interface CardActionMenuProps {
  ariaLabel: string;
  children: ReactNode;
  buttonClassName?: string;
}

export const CardActionMenu = ({ ariaLabel, children, buttonClassName }: CardActionMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className={cn('text-muted-foreground', buttonClassName)}
            aria-label={ariaLabel}
          />
        }
      >
        <DotsThreeIcon className="size-6" weight="bold" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
};
